//Disable all article box for now
Array.from(document.querySelectorAll(".articleBox")).forEach(articleBox => {
    if(!articleBox.classList.contains("alwaysShow")) articleBox.classList.add("d-none");
});

const lowStockTreshold = 5;

const templatesWrapper = document.getElementById("templatesWrapper");

const introSlide = document.getElementById("introSlide");
const orderSelectionSlide = document.getElementById("orderSelectionSlide");
const typeSelectionSlide = document.getElementById("typeSelectionSlide");
const wrongArticleQuestionSlide = document.getElementById("wrongArticleQuestionSlide");
const articleSelectionSlide = document.getElementById("articleSelectionSlide");
const returnQuestionOneSlide = document.getElementById("returnQuestionOneSlide");
const returnQuestionTwoSlide = document.getElementById("returnQuestionTwoSlide");
const returnQuestionThreeSlide = document.getElementById("returnQuestionThreeSlide");
const returnQuestionThreeOtherSlide = document.getElementById("returnQuestionThreeOtherSlide");
const warrantyQuestionOneSlide = document.getElementById("warrantyQuestionOneSlide");
const exchangeSizeSelectionSlide = document.getElementById("exchangeSizeSelectionSlide");
const wrongBootsSizeSelectionSlide = document.getElementById("wrongBootsSizeSelectionSlide");
const wrongBootsShouldReceiveSlide = document.getElementById("wrongBootsShouldReceiveSlide");
const customerInformationSlide = document.getElementById("customerInformationSlide");
const imagesSlide = document.getElementById("imagesSlide");
const finalCheckSlide = document.getElementById("finalCheckSlide");
const requestCreatedSlide = document.getElementById("requestCreatedSlide");
const requestFailedSlide = document.getElementById("requestFailedSlide");

const yourModelTitleClass = "YourModelText";
const newModelTitleClass = "YourRequestedModelText";
const selectedClassName = "selectedReturnRow";

const graceDays = 14;
const maxDaysReturnExchange = 60 + graceDays;
const maxDaysWarranty = 182.5 + graceDays;

const maxDaysReturnExchangeDiscontinued = 0;
const maxDaysWarrantyDiscontinued = 30 + graceDays;

const divSteps = document.getElementsByClassName("divSteps");

const emailInput = document.getElementById("emailInput");
const orderIdInput = document.getElementById("orderIdInput");
const orderIdSelect = document.getElementById("orderIdSelect");
const orderIdElement = document.getElementById("orderIdElement");
const submitOrderChoiceBtn = document.getElementById("submitOrderChoiceBtn");

const invalidStartInfoP = document.getElementById("invalidStartInfoP");

const orderNumberSpan = document.querySelectorAll(".orderNumberSpan");
const orderDateSpan = document.querySelectorAll(".orderDateSpan");

const articleSelectionTitlesWrapper = document.getElementById("articleSelectionTitlesWrapper");
const returnInArticleWrapper = document.getElementById("returnInArticleWrapper");

const typeSelectWrapper = document.getElementById("typeSelectWrapper");
let returnType = "";
let returnReason;
let returnReasonDescription;

const returnTypeArticleBox = document.getElementById("returnTypeArticleBox");
const returnQuestionOneArticleBox = document.getElementById("returnQuestionOneArticleBox");
const returnQuestionTwoArticleBox = document.getElementById("returnQuestionTwoArticleBox");
const returnQuestionThreeArticleBox = document.getElementById("returnQuestionThreeArticleBox");
const returnQuestionThreeOtherArticleBox = document.getElementById("returnQuestionThreeOtherArticleBox");
const warrantyQuestionOneArticleBox = document.getElementById("warrantyQuestionOneArticleBox");
const imageArticleBox = document.getElementById("imageArticleBox");

const returnQuestionThreeWrapper = document.getElementById("returnQuestionThreeWrapper");
const returnQuestionThreeOtherTitle = document.getElementById("returnQuestionThreeOtherTitle");
const returnReasonOtherInput = document.getElementById("otherReturnReason");

const boArtExchangeModelSelectionArticleBox = document.getElementById("boArtExchangeModelSelectionArticleBox");
const boArtNewModelSelectWrapper = document.getElementById("boArtNewModelSelectWrapper");
const boArtNewModelSelect = document.getElementById("boArtNewModelSelect")

const exchangeModelSelectionArticleBox = document.getElementById("exchangeModelSelectionArticleBox");
const newModelSelectWrapper = document.getElementById("newModelSelectWrapper");
const newModelSelect = document.getElementById("newModelSelect")

const exchangeModelReasonArticleBox = document.getElementById("exchangeModelReasonArticleBox");

const exchangeSizeSelectionArticleBox = document.getElementById("exchangeSizeSelectionArticleBox");
const exchangeSizeSelectionSection = document.getElementById("exchangeSizeSelectionSection");
const exchangeSizeSelection = document.getElementById("exchangeSizeSelection");
const exchangeWidthSelectionSection = document.getElementById("exchangeWidthSelectionSection");
const exchangeWidthSelection = document.getElementById("exchangeWidthSelection");

const wrongBootsSizeSelectionArticleBox = document.getElementById("wrongBootsSizeSelectionArticleBox");
const wrongRefInput = document.getElementById("wrongRefInput");
const wrongRefDatalist = document.getElementById("wrongRefDatalist");
const wrongBootsSizeSelectionSection = document.getElementById("wrongBootsSizeSelectionSection");
const wrongBootsSizeSelection = document.getElementById("wrongBootsSizeSelection");
const wrongBootsWidthSelectionSection = document.getElementById("wrongBootsWidthSelectionSection");
const wrongBootsWidthSelection = document.getElementById("wrongBootsWidthSelection");
const wrongBootShouldReceiveArticles = document.getElementById("wrongBootShouldReceiveArticles");

const defectDescriptionWrapper = document.getElementById("defectDescriptionWrapper");
const defectDescriptionTitle = document.getElementById("defectDescriptionTitle");
const defectDescriptionInput = document.getElementById("defectDescriptionInput");
const imageElements = Array.from(document.querySelectorAll(".productImage"));
const imageInputs = Array.from(document.querySelectorAll(".imageInput"));
const imageTitles = Array.from(document.querySelectorAll(".imageTitle"));

const finalCheckRequestType = document.getElementById("finalCheckRequestType");
const finalCheckLowOnStockWarning = document.getElementById("finalCheckLowOnStockWarning");
const finalCheckOutOfStockWarning = document.getElementById("finalCheckOutOfStockWarning");
const finalCheckReturnIn = document.getElementById("finalCheckReturnIn");
const finalCheckReturnOutArrow = document.getElementById("finalCheckReturnOutArrow");
const finalCheckReturnOut = document.getElementById("finalCheckReturnOut");
const finalCheckReasonWrapper = document.getElementById("finalCheckReasonWrapper");
const finalCheckReason = document.getElementById("finalCheckReason");
const finalCheckShippingAddressWrapper = document.getElementById("finalCheckShippingAddressWrapper");

const finalCheckImagesWrapper = document.getElementById("finalCheckImagesWrapper");
const finalCheckImages = document.getElementById("finalCheckImages");
const agreeTermsCheckboxInput = document.getElementById("agreeTermsCheckboxInput");

const shippingAddressInfoWrapper = document.getElementById("shippingAddressInfoWrapper");
const finalCheckShippingFName = document.getElementById("finalCheckShippingFName");
const finalCheckShippingLName = document.getElementById("finalCheckShippingLName");
const finalCheckShippingCompanyWrapper = document.getElementById("finalCheckShippingCompanyWrapper");
const finalCheckShippingCompany = document.getElementById("finalCheckShippingCompany");
const finalCheckShippingAddress = document.getElementById("finalCheckShippingAddress");
const finalCheckShippingLoc = document.getElementById("finalCheckShippingLoc");
const finalCheckShippingLocWrapper = document.getElementById("finalCheckShippingLocWrapper");
const finalCheckShippingCity = document.getElementById("finalCheckShippingCity");
const finalCheckShippingState = document.getElementById("finalCheckShippingState");
const finalCheckShippingCPostal = document.getElementById("finalCheckShippingCPostal");
const finalCheckShippingPhone = document.getElementById("finalCheckShippingPhone");
const finalCheckShippingPhoneWrapper = document.getElementById("finalCheckShippingPhoneWrapper");

const editShippingAddressBtn = document.getElementById("editShippingAddressBtn");

const shippingAddressEditWrapper = document.getElementById("shippingAddressEditWrapper");
const shippingAddressEditFName = document.getElementById("shippingAddressEditFName");
const shippingAddressEditLName = document.getElementById("shippingAddressEditLName");
const shippingAddressEditCompany = document.getElementById("shippingAddressEditCompany");
const shippingAddressEditAddress = document.getElementById("shippingAddressEditAddress");
const shippingAddressEditLoc = document.getElementById("shippingAddressEditLoc");
const shippingAddressEditCity = document.getElementById("shippingAddressEditCity");
const shippingAddressEditState = document.getElementById("shippingAddressEditState");
const shippingAddressEditCPostal = document.getElementById("shippingAddressEditCPostal");
const shippingAddressEditPhone = document.getElementById("shippingAddressEditPhone");

const saveShippingAddressEditBtn = document.getElementById("saveShippingAddressEditBtn");

const requestTypeConfirmation = document.getElementById("requestTypeConfirmation");

const requestCreatedEmailP = document.getElementById("requestCreatedEmailP");
const requestFailedEmailP = document.getElementById("requestFailedEmailP");

let nbOfSlides = 0;
let selectedOrder = null;
let crtSelectedRow = null;
let selectedItemIn = null;
let returnInSelectedSref1 = null;
let returnInSelectedSref2 = null;

let selectedItemOut = null;
let returnOutSelectedSref1 = null;
let returnOutSelectedSref2 = null;

let selectedWrongItem = null;
let wrongBootsSelectedSref1 = null;
let wrongBootsSelectedSref2 = null;

let possibleArticles;

const swiperPrevBtnClass = "swiper-button-prev"
const swiperNextBtnClass = "swiper-button-next"

const nextBtn = document.getElementById("nextBtn");
const sendBtn = document.getElementById("sendBtn");

sendBtn.addEventListener("click", post)

getPossibleArticles();

let timer = null;

let swiperReturn = new Swiper(".swiper-returns", {
    // Optional parameters
    direction: "horizontal",
    shortSwipes: false,
    simulateTouch: false,
    slideToClickedSlide: false,
    loop: false,
    speed: 200,
    autoHeight: true,
    effect: "slide",
    allowSlideNext: false,
    allowTouchMove: false,
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    },
    //allowSlidePrev: false,
    //allowTouchMove: false,
    // Navigation arrows
    navigation: {
        nextEl: "." + swiperNextBtnClass,
        prevEl: "." + swiperPrevBtnClass,
    },
    on: {
        slideChange: (swiper) => slideChange(swiper),
        beforeInit: () => { nbOfSlides = document.querySelector(".swiper-returns").querySelectorAll(".swiper-slide").length; },
        slideChangeTransitionStart: (swiper) => slideChangeTransitionStart(swiper),
        slideChangeTransitionEnd: (swiper) => slideChangeTransitionEnd(swiper)
    },
});

const swiperEl = swiperReturn.el;
const swiperPrevBtnEl = swiperEl.querySelector("." + swiperPrevBtnClass);
const swiperNextBtnEl = swiperEl.querySelector("." + swiperNextBtnClass);

window.addEventListener("focus", () => {
    timer = performance.now()
});

Array.from(document.getElementsByClassName("finalCheckEditBtn")).forEach(btn => {
    if (!btn.classList.contains("noSlideChange")) {
        btn.addEventListener("click", () => {
            let slideEl = document.getElementById(btn.dataset.slideId);
            if (!slideEl) {
                if (returnType == "R" || returnType == "R-W") {
                    slideEl = returnQuestionTwoSlide
                }
                else if (returnType == "W") {
                    slideEl = warrantyQuestionOneSlide
                }
            }
            if (!slideEl) console.log("No slide with the id '" + btn.dataset.slideId + "' was found")
            else {
                swiperReturn.slideTo(getIndexOfChild(slideEl));
            }
        })
    }
});

agreeTermsCheckboxInput.addEventListener("change", () => {
    sendBtn.disabled = !agreeTermsCheckboxInput.checked;
});

function toBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
    })
}

async function post() {
    //show the loader
    if (loader) loader.style.setProperty('display', 'flex', 'important');

    const prodUrl = royerApiBaseAddress + "return-exchange-warranty-request/create-request"
    const devUrl = royerApiLocalhostBaseAddress + "return-exchange-warranty-request/create-request"

    const postUrl = devMode ? devUrl : prodUrl;

    const request = {
        shopify_id: parseInt(orderIdElement.value),
        user_id: typeof userId !== 'undefined' ? userId : 0,
        user_email: emailInput?.value,
        //Don't keep the wrong boot suffix because it's shown in the article itself
        type: returnType.endsWith("-W") ? returnType.slice(0, -2) : returnType,
        no_site: siteNb,
        reason: returnReason,
        reason_description: returnReasonDescription,
        shipping_address_id: selectedOrder.shipping_address_id,
        /*No need to pass the address if it didn't change*/
        shipping_address: selectedOrder.shipping_address_id ? null : selectedOrder.shipping_address,
        items: [{ nun: selectedItemIn.nun, ref: selectedItemIn.ref, sref1: selectedItemIn.sref1, sref2: selectedItemIn.sref2, direction: 1, wrong_ref: selectedWrongItem?.ref, wrong_sref1: selectedWrongItem?.sref1, wrong_sref2: selectedWrongItem?.sref2 }],
        images: (await Promise.all(
            imageInputs.map(async (imgInput) => {
                if (imgInput.files.length === 0) return null;
                return {
                name: imgInput.dataset.type,
                base64: await toBase64(imgInput.files[0]),
                };
            })
        )).filter(x => x !== null)
    };
    //If this is an exchange add the return out to the list of items
    if (returnType == "E" || returnType == "E-W") {
        request.items.push({ ref: selectedItemOut.ref, sref1: selectedItemOut.sref1, sref2: selectedItemOut.sref2, direction: 2, ori_nun: selectedItemIn.nun });
    }
    else if (returnType == "W") {
        request.items.push({ ref: selectedItemIn.ref, sref1: selectedItemIn.sref1, sref2: selectedItemIn.sref2, direction: 2, ori_nun: selectedItemIn.nun });
    }
    var myHeaders = new Headers();
    myHeaders.append('Authorization', "Basic TVZobGVsa3FScDk0TlI2NTFseXM6c2ZIUnpVT1FGcEcxclJ6WGx1bE0=");
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('Content-Length', '0');

    let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        redirect: 'follow',
        scheme: 'https',
        mode: 'cors',
        cache: 'no-cache',
        body: JSON.stringify(request)
    };

    fetch(postUrl, requestOptions)
        .then(response => response.text())
        .then(result => {
            //Hide the loader again
            if (loader) loader.style.display = "";
            let createRequestResult = JSON.parse(result);
            if (createRequestResult.request_created) {
                allowNextSlideBtn(true);
                requestCreatedEmailP.innerText = createRequestResult.user_email;
                let returnTypeText = null;
                if (returnType == "R" || returnType == "R-W") returnTypeText = templatesWrapper.querySelector(".returnText").innerText
                if (returnType == "E" || returnType == "E-W") returnTypeText = templatesWrapper.querySelector(".exchangeText").innerText
                if (returnType == "W") returnTypeText = templatesWrapper.querySelector(".warrantyText").innerText
                requestTypeConfirmation.innerText = returnTypeText;
                swiperNextBtnEl.classList.remove("swiperBtn");
                swiperPrevBtnEl.classList.remove("swiperBtn");
                swiperReturn.slideTo(getIndexOfChild(requestCreatedSlide));
            }
            else {
                allowNextSlideBtn(true);
                swiperNextBtnEl.classList.remove("swiperBtn");
                swiperPrevBtnEl.classList.remove("swiperBtn");
                swiperReturn.slideTo(getIndexOfChild(requestFailedSlide));
            }
        })
        .catch(error => {
            //Hide the loader again
            if (loader) loader.style.display = "";
            console.log(error)
            allowNextSlideBtn(true);
            swiperReturn.slideTo(getIndexOfChild(requestFailedSlide));
            swiperNextBtnEl.classList.remove("swiperBtn");
            swiperPrevBtnEl.classList.remove("swiperBtn");
        });
}

async function getPossibleArticles() {
    const prodUrl = royerApiBaseAddress + `return-exchange-warranty-request/get-possible-articles?noSite=${siteNb}`
    const devUrl = royerApiLocalhostBaseAddress + `return-exchange-warranty-request/get-possible-articles?noSite=${siteNb}`

    const getUrl = devMode ? devUrl : prodUrl;

    var myHeaders = new Headers();
    myHeaders.append('Authorization', "Basic TVZobGVsa3FScDk0TlI2NTFseXM6c2ZIUnpVT1FGcEcxclJ6WGx1bE0=");
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('Content-Length', '0');

    let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow',
        scheme: 'https',
        mode: 'cors',
        cache: 'no-cache'
    };

    fetch(getUrl, requestOptions)
        .then(response => response.text())
        .then(result => {
            //Hide the loader again
            possibleArticles = JSON.parse(result);

            possibleArticles.forEach(article => {
                const option = document.createElement("option");
                option.innerText = article.ref;
                wrongRefDatalist.appendChild(option);
            });
        })
        .catch(error => {
            console.log(error)
        });
}

function startReturnBtnClicked() {
    allowNextSlideBtn(true);
    swiperReturn.slideNext();
}

function startBtnClickedLoggedIn() {
    if (selectedOrder) {
        allowNextSlideBtn(true);
        swiperReturn.slideNext();
    }
}

function startBtnClicked() {
    //If the order is the same that was already loaded don't load it again
    if (selectedOrder && selectedOrder.shopify_id == orderIdInput.value.trim()) {
        invalidStartInfoP.classList.add("invisible");

        swiperReturn.allowSlideNext = true;
        swiperReturn.slideNext();

        return;
    }
    const prodUrl = royerApiBaseAddress + "return-exchange-warranty-request/customer-order"
    const devUrl = royerApiLocalhostBaseAddress + "return-exchange-warranty-request/customer-order"
    const getCustomerOrderUrl = devMode ? devUrl : prodUrl;

    var myHeaders = new Headers();
    myHeaders.append('Authorization', "Basic TVZobGVsa3FScDk0TlI2NTFseXM6c2ZIUnpVT1FGcEcxclJ6WGx1bE0=");
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('Content-Length', '0');

    let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow',
        scheme: 'https',
        mode: 'cors',
        cache: 'no-cache'
    };

    //show the loader
    if (loader) loader.style.setProperty('display', 'flex', 'important');

    fetch(`${getCustomerOrderUrl}?noSite=${siteNb}&email=${emailInput.value}&shopifyOrderId=${orderIdInput.value}`, requestOptions)
        .then(response => response.text())
        .then(result => {
            selectedOrder = JSON.parse(result);
            if (selectedOrder) {
                //Set selected order ID
                orderIdElement.value = orderIdInput.value;

                //Reset step 2
                returnType = "";
                setupStep2(selectedOrder);

                //Reset step 3
                resetStep3In();
                resetStep3Out();
                setupStep3(selectedOrder);

                orderNumberSpan.forEach(nbSpan => nbSpan.innerText = selectedOrder.shopify_id);
                orderDateSpan.forEach(dateSpan => dateSpan.innerText = formatDate(new Date(selectedOrder.creation_date)));
                
                invalidStartInfoP.classList.add("invisible");

                swiperReturn.allowSlideNext = true;
                swiperReturn.slideNext();
            }
            else {
                invalidStartInfoP.classList.remove("invisible");
            }
            //Hide the loader again
            if (loader) loader.style.display = "";
        })
        .catch(error => {
            //Hide the loader again
            if (loader) loader.style.display = "";
            console.log(error)
            allowNextSlideBtn(true);
            swiperReturn.slideTo(getIndexOfChild(requestFailedSlide));
            swiperNextBtnEl.classList.remove("swiperBtn");
            swiperPrevBtnEl.classList.remove("swiperBtn");
        });
}

function orderSelectChange(e) {
    const selectedOrderId = e.target.value
    selectedOrder = orders.find(order => order.shopify_id == selectedOrderId)

    //Set selected order ID
    orderIdElement.value = selectedOrderId;

    //Reset step 2
    returnType = "";
    setupStep2(selectedOrder);

    //Reset step 3
    resetStep3In();
    resetStep3Out();
    setupStep3(selectedOrder);

    orderNumberSpan.forEach(nbSpan => nbSpan.innerText = selectedOrder.shopify_id);
    orderDateSpan.forEach(dateSpan => dateSpan.innerText = formatDate(new Date(selectedOrder.creation_date)));

    submitOrderChoiceBtn.disabled = false;
}

function setupStep2(order) {
    const nbOfDaysSinceShipping = (new Date() - new Date(order.shipped_date)) / (1000 * 3600 * 24);

    const typeDivs = Array.from(typeSelectWrapper.querySelectorAll(".returnRequestSelectableDiv"));

    const adminInfoReturnWrapper = typeSelectWrapper.querySelector(".returnRequestAdminWrapper[data-value='R']");
    const adminInfoExchangeWrapper = typeSelectWrapper.querySelector(".returnRequestAdminWrapper[data-value='E']");

    if (nbOfDaysSinceShipping < maxDaysReturnExchange) {
      adminInfoReturnWrapper.classList.add("d-none");
      adminInfoExchangeWrapper.classList.add("d-none");
      typeDivs.find(div => div.dataset.value == "R").classList.remove("disabled");
      typeDivs.find(div => div.dataset.value == "E").classList.remove("disabled");
    }
    else {
      typeDivs.find(div => div.dataset.value == "R").classList.add("disabled");
      typeDivs.find(div => div.dataset.value == "E").classList.add("disabled");

      isIpRestricted().then(isRestricted => {
        
        console.log(adminInfoReturnWrapper)
        if (isRestricted){
          typeDivs.find(div => div.dataset.value == "R").classList.remove("disabled");
          typeDivs.find(div => div.dataset.value == "E").classList.remove("disabled");
          adminInfoReturnWrapper.classList.remove("d-none");
          adminInfoExchangeWrapper.classList.remove("d-none");
        }
        else{
          adminInfoReturnWrapper.classList.add("d-none");
          adminInfoExchangeWrapper.classList.add("d-none");
        }

      });
    }
    if (nbOfDaysSinceShipping < maxDaysWarranty) {
        typeDivs.find(div => div.dataset.value == "W").classList.remove("disabled");
    }
    else {
      typeDivs.find(div => div.dataset.value == "W").classList.add("disabled");

      isIpRestricted().then(isRestricted => {
        const adminInfoWarrantyWrapper = typeSelectWrapper.querySelector(".returnRequestAdminWrapper[data-value='W']");
        if (isRestricted){
          typeDivs.find(div => div.dataset.value == "W").classList.remove("disabled");
          adminInfoWarrantyWrapper.classList.remove("d-none");
        }
        else {
          adminInfoWarrantyWrapper.classList.add("d-none");
        }
      });
    }
}

function resetStep3In() {
    selectedItemIn = null;
    crtSelectedRow?.classList.remove(selectedClassName);
    crtSelectedRow = null;
    returnInArticleWrapper.innerHTML = "";
}

function resetStep3Out() {
    selectedItemOut = null;
    returnOutSelectedSref1 = null;
    returnOutSelectedSref2 = null;
    exchangeSizeSelection.innerHTML = "";
    exchangeWidthSelection.innerHTML = "";
}

function setupStep3(order) {    
    order.items.forEach(item => {
        const articleEl = createArticleElement(item);
        articleEl.onclick = rowSelected;
        returnInArticleWrapper.appendChild(articleEl);
    });

    crtSelectedRow?.classList.remove(selectedClassName);
    crtSelectedRow = null;
    selectedItemIn = null;
    resetWrongItemSelection();
}

function resetWrongItemSelection(resetRefInput = true) {
    selectedWrongItem = null;
    if (resetRefInput) wrongRefInput.value = "";
    wrongBootsSizeSelection.innerHTML = "";
    wrongBootsWidthSelection.innerHTML = "";
    wrongBootsSelectedSref1 = null;
    wrongBootsSelectedSref2 = null;
    wrongBootsSizeSelectionArticleBox.innerHTML = "";
    wrongBootsSizeSelectionSection.classList.add("d-none")
    wrongBootsWidthSelectionSection.classList.add("d-none")
}

function wrongItemReceived() {
    if (!returnType.endsWith("-W")) returnType = returnType + '-W';
    wrongBootShouldReceiveArticles.innerHTML = "";
    selectedOrder.items.forEach(item => {
        const articleEl = createArticleElement(item);
        articleEl.onclick = rowSelected;
        wrongBootShouldReceiveArticles.appendChild(articleEl);
    });
    allowNextSlideBtn(true);
    swiperReturn.slideNext();
}

function wrongRefInputChange() {
    if (Array.from(wrongRefDatalist.options).some(option => option.innerText == wrongRefInput.value)) {
        selectedWrongItem = {
            ref: wrongRefInput.value,
            sref1: null,
            sref2: null,
            stocks: possibleArticles.find(art => art.ref == wrongRefInput.value).sizes.map(size => {
                return {
                    depo: "U2",
                    ref: wrongRefInput.value,
                    resqte: 0,
                    stqte: 0,
                    sref1: size.sref1,
                    sref2: size.sref2,
                }
            })
        };
        const img = document.createElement("img");
        img.src = baseCdnPath + wrongRefInput.value + "_SIDE.jpg";
        img.width = "150";
        img.height = "150";
        img.className = "border rounded"
        img.onerror = () => {
            const fallbackSrc = baseCdnPathFallback + wrongRefInput.value + "_SIDE.jpg";
            if (img.src != fallbackSrc) img.src = fallbackSrc;
        };
        wrongBootsSizeSelectionArticleBox.appendChild(img);

        swiperReturn.update();

        const setSelectedSref1Func = (newSelectedSref1) => wrongBootsSelectedSref1 = newSelectedSref1;
        const setSelectedSref2Func = (newSelectedSref2) => wrongBootsSelectedSref2 = newSelectedSref2;
        const getSelectedSref1Func = () => { return wrongBootsSelectedSref1 };
        const getSelectedSref2Func = () => { return wrongBootsSelectedSref2 };
        setupSrefSelection(wrongBootsSizeSelectionSection, wrongBootsSizeSelection, wrongBootsWidthSelectionSection, wrongBootsWidthSelection, setSelectedSref1Func, getSelectedSref1Func, setSelectedSref2Func, getSelectedSref2Func, selectedWrongItem, null, false);
    }
    else {
        resetWrongItemSelection(false);
        swiperReturn.update();
    }
}

function typeSelectChange(type) {
    //If the type isn't disabled
    if (!typeSelectWrapper.querySelector(`.returnRequestSelectableDiv[data-value=${type}]`).classList.contains("disabled")) {
        //Deselect selected item
        resetStep3Out();

        selectedItemOut = null;
        returnOutSelectedSref1 = null;
        returnOutSelectedSref2 = null;

        returnType = type + (returnType == "-W" ? returnType : "");

        if (returnType == "E" || returnType == "E-W") {
            selectedItemOut = { ...selectedItemIn };
            selectedItemOut.nun = null;
            selectedItemOut.sref1 = null;
            selectedItemOut.sref2 = null;
        }

        //If the type is a return
        if (returnType == "R" || returnType == "R-W") {
            fillArticleBox(returnQuestionOneArticleBox, selectedWrongItem ?? selectedItemIn)
        }
        //If the type is exchange show the size selection section
        else if (returnType == "E" || returnType == "E-W") {
            setupReturnOut();
        }
        //If the type is a warranty
        else if (returnType == "W") {
            fillArticleBox(warrantyQuestionOneArticleBox, selectedItemIn)
        }
        allowNextSlideBtn(true);
        swiperReturn.slideNext();
    }
}

function fillArticleBox(articleBox, item, titleClass = yourModelTitleClass) {
    articleBox.innerHTML = createArticleElement(item, titleClass).outerHTML;
    articleBox.children[0].classList.remove("selectedReturnRow");
    articleBox.children[0].classList.add("noHover");
}

function rowSelected(e) {
    const row = e.target.closest(".articleRow");

    //If the article isn't available do nothing
    if (row.classList.contains("articleNotAvailable")) return;

    selectedItemIn = selectedOrder.items.find(item => item.nun == row.dataset.nun);

    //If a row was already selected remove the class from it
    if (crtSelectedRow) crtSelectedRow.classList.remove(selectedClassName);

    returnOutSelectedSref1 = null;
    returnOutSelectedSref2 = null;

    crtSelectedRow = row;
    crtSelectedRow.classList.add(selectedClassName);

    fillArticleBox(returnTypeArticleBox, selectedWrongItem ?? selectedItemIn)

    swiperNextBtnEl.classList.add("swiperBtn")

    //If the article is discontinued and it was discontinued when they bought it
    let useDiscontinuedLogic = selectedItemIn.discontinued_date != null && selectedItemIn.discontinued_date < selectedOrder.creation_date;

    const nbOfDaysSinceShipping = (new Date() - new Date(selectedOrder.shipped_date)) / (1000 * 3600 * 24);

    const typeDivs = Array.from(typeSelectWrapper.querySelectorAll(".returnRequestSelectableDiv"));
    if ((!useDiscontinuedLogic && nbOfDaysSinceShipping < maxDaysReturnExchange) || (useDiscontinuedLogic && nbOfDaysSinceShipping < maxDaysReturnExchangeDiscontinued)) {
      typeDivs.find(div => div.dataset.value == "R").classList.remove("disabled");
      typeDivs.find(div => div.dataset.value == "E").classList.remove("disabled");
    }
    else {
      typeDivs.find(div => div.dataset.value == "R").classList.add("disabled");
      typeDivs.find(div => div.dataset.value == "E").classList.add("disabled");

      isIpRestricted().then(isRestricted => {
        const adminInfoReturnWrapper = typeSelectWrapper.querySelector(".returnRequestAdminWrapper[data-value='R']");
        const adminInfoExchangeWrapper = typeSelectWrapper.querySelector(".returnRequestAdminWrapper[data-value='E']");
        if (isRestricted){
          typeDivs.find(div => div.dataset.value == "R").classList.remove("disabled");
          typeDivs.find(div => div.dataset.value == "E").classList.remove("disabled");
          adminInfoReturnWrapper.classList.remove("d-none");
          adminInfoExchangeWrapper.classList.remove("d-none");
        }
        else{
          adminInfoReturnWrapper.classList.add("d-none");
          adminInfoExchangeWrapper.classList.add("d-none");
        }

      });
    }
    if ((!useDiscontinuedLogic && nbOfDaysSinceShipping < maxDaysWarranty) || (useDiscontinuedLogic && nbOfDaysSinceShipping < maxDaysWarrantyDiscontinued)) {
        typeDivs.find(div => div.dataset.value == "W").classList.remove("disabled");
    }
    else {
      typeDivs.find(div => div.dataset.value == "W").classList.add("disabled");

      isIpRestricted().then(isRestricted => {
        const adminInfoWarrantyWrapper = typeSelectWrapper.querySelector(".returnRequestAdminWrapper[data-value='W']");
        if (isRestricted){
          typeDivs.find(div => div.dataset.value == "W").classList.remove("disabled");
          adminInfoWarrantyWrapper.classList.remove("d-none");
        }
        else {
          adminInfoWarrantyWrapper.classList.add("d-none");
        }
      });
    }

    swiperNextBtnEl.scrollIntoView(false);
    allowNextSlideBtn(true);
}

function returnTurnedExchanged() {
    if (returnType == "R") returnType = "E";
    else if (returnType == "R-W") returnType = "E-W";

    selectedItemIn = selectedOrder.items.find(item => item.nun == crtSelectedRow.dataset.nun);
    selectedItemOut = { ...selectedItemIn };
    selectedItemOut.sref1 = null;
    selectedItemOut.sref2 = null;

    setupReturnOut();

    allowNextSlideBtn(true);
    swiperReturn.slideNext();
}

function refundFullAmountClicked() {
    fillArticleBox(returnQuestionTwoArticleBox, selectedItemIn);
    allowNextSlideBtn(true);
    swiperReturn.slideNext();
}

function returnQuestionTwoClick(el) {
    const type = el.dataset.type;
    returnReason = type;

    let shownChild = [];
    Array.from(returnQuestionThreeWrapper.children).forEach(child => {
        if (child.dataset.type == type) {
            shownChild.push(child);
            child.classList.remove("d-none");
        }
        else child.classList.add("d-none");
    });

    fillArticleBox(returnQuestionThreeArticleBox, selectedItemIn);

    returnReasonOtherInput.value = "";

    allowNextSlideBtn(true);
    if (returnReason == "other") swiperReturn.slideTo(getIndexOfChild(returnQuestionThreeOtherSlide));
    else swiperReturn.slideNext();
}

function returnQuestionThreeClick(el) {
    const type = el.dataset.type.split("_");
    const baseType = type[0];
    const lastType = type[1];

    returnReason = el.dataset.type

    //Reset "other" text area
    returnReasonOtherInput.value = "";

    if (lastType == "other") {
        fillArticleBox(returnQuestionThreeOtherArticleBox, selectedItemIn);
        returnQuestionThreeOtherTitle.innerText = returnQuestionTwoSlide.querySelector("div[data-type=" + baseType + "]")?.querySelector(".selectableDivText")?.innerText;
        allowNextSlideBtn(true);
        swiperReturn.slideTo(getIndexOfChild(returnQuestionThreeOtherSlide));
        swiperNextBtnEl.classList.add("swiperBtn")
        allowNextSlideBtn(true);
    }
    else {
        allowNextSlideBtn(true);
        swiperReturn.slideTo(getIndexOfChild(imagesSlide));
    }
}

function warrantyQuestionOneClick(el) {
    returnReason = el.dataset.type

    allowNextSlideBtn(true);
    swiperReturn.slideNext();
}

function setupReturnOut() {
    const showStockOnBtn = false;
    fillArticleBox(exchangeSizeSelectionArticleBox, selectedItemOut ?? selectedItemIn, selectedItemOut ? newModelTitleClass : yourModelTitleClass);
    const setSelectedSref1Func = (newSelectedSref1) => returnOutSelectedSref1 = newSelectedSref1;
    const setSelectedSref2Func = (newSelectedSref2) => returnOutSelectedSref2 = newSelectedSref2;
    const getSelectedSref1Func = () => { return returnOutSelectedSref1 };
    const getSelectedSref2Func = () => { return returnOutSelectedSref2 };
    setupSrefSelection(exchangeSizeSelectionSection, exchangeSizeSelection, exchangeWidthSelectionSection, exchangeWidthSelection, setSelectedSref1Func, getSelectedSref1Func, setSelectedSref2Func, getSelectedSref2Func, selectedItemOut, selectedWrongItem ? null : selectedItemIn, showStockOnBtn);
}

function setupSrefSelection(sizeSelectionSection, sizeSelection, widthSelectionSection, widthSelection, setSelectedSref1Func, getSelectedSref1Func, setSelectedSref2Func, getSelectedSref2Func, item, itemToDisableSizeFor = null, showStock = true) {
    sizeSelection.innerHTML = "";
    widthSelection.innerHTML = "";
    const possibleSref1 = [...new Set(item.stocks.map((item) => item.sref1))];
    const possibleSref2 = [...new Set(item.stocks.map((item) => item.sref2))];

    if (possibleSref2.length < 2) sizeSelectionSection.classList.add("d-none");
    else sizeSelectionSection.classList.remove("d-none");

    if (possibleSref1.length < 2) widthSelectionSection.classList.add("d-none");
    else widthSelectionSection.classList.remove("d-none");

    possibleSref1.forEach(sref1 => {
        let variantBtn = document.createElement("button");
        variantBtn.classList.add("variantBtn");
        variantBtn.dataset.value = sref1;
        variantBtn.innerHTML = sref1;
        variantBtn.onclick = (e) => { newSref1Selected(e, sizeSelection, widthSelection, setSelectedSref1Func, getSelectedSref1Func, getSelectedSref2Func, item, itemToDisableSizeFor, showStock) };;
        //Automaticly select the option if it's the only one
        if (possibleSref1.length == 1) {
            variantBtn.classList.add("selected")
            setSelectedSref1Func(variantBtn);
            item.sref1 = possibleSref1[0];
        };

        widthSelection.appendChild(variantBtn);
    });

    possibleSref2.forEach(sref2 => {
        let variantBtn = document.createElement("button");
        variantBtn.classList.add("variantBtn");
        //If the sref1 currently selected and the current size button beeing created are the same as the selected item and the model is the same disable the button
        if (itemToDisableSizeFor && item.ref == itemToDisableSizeFor.ref && item.sref1 == itemToDisableSizeFor.sref1 && sref2 == itemToDisableSizeFor.sref2) {
            variantBtn.disabled = true;
            variantBtn.title = "";
        }
        variantBtn.dataset.value = sref2;
        variantBtn.innerHTML = sref2;
        variantBtn.onclick = (e) => { newSref2Selected(e, sizeSelection, widthSelection, getSelectedSref1Func, setSelectedSref2Func, getSelectedSref2Func, item, itemToDisableSizeFor, showStock) };
        //Automaticly select the option if it's the only one
        if (possibleSref2.length == 1) {
            variantBtn.classList.add("selected");
            setSelectedSref2Func(variantBtn);
            item.sref2 = possibleSref2[0];
        }

        sizeSelection.appendChild(variantBtn);
    });

    updateSizeBtnStockStyle(sizeSelection, widthSelection, getSelectedSref1Func(), getSelectedSref2Func(), item, itemToDisableSizeFor, showStock);

    //Force the swiper to update the height after showing the size select section
    swiperReturn.update();
}

function newSref1Selected(e, sizeSelection, widthSelection, setSelectedSref1Func, getSelectedSref1Func, getSelectedSref2Func, item, itemToDisableSizeFor = null, showStock = true) {
    let selectedSref1 = getSelectedSref1Func();
    if (selectedSref1) selectedSref1.classList.remove("selected");
    selectedSref1 = e.target.closest("button")
    setSelectedSref1Func(selectedSref1);
    selectedSref1.classList.add("selected");

    item.sref1 = selectedSref1.dataset.value;

    updateSizeBtnStockStyle(sizeSelection, widthSelection, selectedSref1, getSelectedSref2Func(), item, itemToDisableSizeFor, showStock);

    if (checkSrefSelection(selectedSref1, getSelectedSref2Func(), item)) {
        swiperNextBtnEl.classList.add("swiperBtn")
        allowNextSlideBtn(true);
    }
}

function newSref2Selected(e, sizeSelection, widthSelection, getSelectedSref1Func, setSelectedSref2Func, getSelectedSref2Func, item, itemToDisableSizeFor = null, showStock = true) {
    let selectedSref2 = getSelectedSref2Func();
    if (selectedSref2) selectedSref2.classList.remove("selected");
    selectedSref2 = e.target.closest("button")
    setSelectedSref2Func(selectedSref2);
    selectedSref2.classList.add("selected");

    item.sref2 = selectedSref2.dataset.value;

    updateSizeBtnStockStyle(sizeSelection, widthSelection, getSelectedSref1Func(), selectedSref2, item, itemToDisableSizeFor, showStock);

    if (checkSrefSelection(getSelectedSref1Func(), selectedSref2, item)) {
        swiperNextBtnEl.classList.add("swiperBtn")
        allowNextSlideBtn(true);
    }
}

function checkSrefSelection(selectedSref1, selectedSref2, item) {
    if (selectedSref2 && selectedSref1) {
        const stockObj = item.stocks.find(stock => stock.ref == item.ref && stock.sref1 == selectedSref1.dataset.value && stock.sref2 == selectedSref2.dataset.value)
        if (stockObj) return true;
        else return false;
    }
}

function updateSizeBtnStockStyle(sizeSelectionWrapper, widthSelectionWrapper, selectedSref1, selectedSref2, item, itemToDisableSizeFor = null, showStock = true) {
    const stockTitlePrefix = templatesWrapper.querySelector(".articleStockAvailable").innerText;
    const sref2Btns = sizeSelectionWrapper.querySelectorAll(".variantBtn");
    const sref1Btns = widthSelectionWrapper.querySelectorAll(".variantBtn");

    if (selectedSref1) {
        sref2Btns.forEach(btn => {
            const stockObj = item.stocks.find(stock => stock.ref == item.ref && stock.sref1 == item.sref1 && stock.sref2 == btn.dataset.value)
            if (stockObj) {
                if (itemToDisableSizeFor)
                    btn.disabled = itemToDisableSizeFor.ref == item.ref && itemToDisableSizeFor.sref1 == item.sref1 && btn.dataset.value == itemToDisableSizeFor.sref2;
                else btn.disabled = false;
                if (showStock) {
                    const stock = stockObj.stqte - stockObj.resqte;
                    btn.title = stockTitlePrefix + (stock < 0 ? 0 : stock);
                    btn.classList.remove("noStocks");
                    btn.classList.remove("lowStocks");
                    if (stock <= 0) btn.classList.add("noStocks");
                    else if (stock < lowStockTreshold) btn.classList.add("lowStocks");
                }
            }
            else {
                btn.disabled = true;
                btn.title = "";
            }
        });
    }
    else {
        sref2Btns.forEach(btn => {
            btn.classList.remove("noStocks");
            btn.classList.remove("lowStocks");
            btn.title = "";
        });
    }
    if (selectedSref2) {
        sref1Btns.forEach(btn => {
            const stockObj = item.stocks.find(stock => stock.ref == item.ref && stock.sref1 == btn.dataset.value && stock.sref2 == item.sref2)
            if (stockObj) {
                if (itemToDisableSizeFor)
                    btn.disabled = itemToDisableSizeFor.ref == item.ref && itemToDisableSizeFor.sref2 == item.sref2 && btn.dataset.value == itemToDisableSizeFor.sref1;
                else btn.disabled = false;
                if (showStock) {
                    const stock = stockObj.stqte - stockObj.resqte;
                    btn.title = stockTitlePrefix + (stock < 0 ? 0 : stock);
                    btn.classList.remove("noStocks");
                    btn.classList.remove("lowStocks");
                    if (stock <= 0) btn.classList.add("noStocks");
                    else if (stock < lowStockTreshold) btn.classList.add("lowStocks");
                }
            }
            else {
                btn.disabled = true;
                btn.title = "";
            }
        });
    }
    else {
        sref1Btns.forEach(btn => {
            btn.classList.remove("noStocks");
            btn.classList.remove("lowStocks");
            btn.title = "";
        });
    }
}

function changeImageBtnClicked(btnEl) {
    const fileInput = btnEl.querySelector("input[type='file']");
    fileInput.click();
}

function imageChange(fileInput) {
    if (fileInput.files && fileInput.files[0]) {
        let reader = new FileReader();
        const fileName = fileInput.files[0].name;
        reader.onload = (e) => {
            const imageWrapper = fileInput.closest("button");
            const imgEl = imageWrapper.querySelector("img");
            imgEl.src = e.target.result;
            //Alt text is set to the file name without the extension
            imgEl.alt = fileName.split(".")[0]

            imageWrapper.classList.remove("emptyImage")

            //if all the images are now filled allow next slide
            let allImageFilled = imageInputs.every(input => Array.from(input.files).filter(file => file.type.includes('image')).length != 0);
            allowNextSlideBtn(allImageFilled);
            if (allImageFilled) swiperNextBtnEl.classList.add("swiperBtn");
            else swiperNextBtnEl.classList.remove("swiperBtn");
        };
        reader.readAsDataURL(fileInput.files[0]);
    }
}

function createArticleElement(item, titleClass, showNun = false) {
    let row = document.createElement("div");
    row.classList.add("articleRow");
    row.dataset.nun = item.nun;

    let imgWrapperDiv = document.createElement("div");
    let itemImg = document.createElement("img");
    itemImg.src = baseCdnPath + item.ref + "_SIDE.jpg";
    itemImg.onerror = () => {
        const fallbackSrc = baseCdnPathFallback + item.ref + "_SIDE.jpg";
        if (itemImg.src != fallbackSrc) itemImg.src = fallbackSrc;
    };
    itemImg.classList.add("articleImg");
    imgWrapperDiv.classList.add("articleImgWrapperDiv");
    imgWrapperDiv.appendChild(itemImg);

    let articleWrapperDiv = document.createElement("div");
    let refDiv = document.createElement("div");
    refDiv.innerHTML = "<b>" + (templatesWrapper.querySelector("." + titleClass)?.innerText ?? "") + "</b>" + item.ref + (item.sref1 ? "-" : "") + (item.sref1 ?? "") + (item.sref2 ? "-" : "") + (item.sref2 ?? "");
    refDiv.classList.add("articleRefWrapperDiv");

    let priceDiv = document.createElement("div");
    if (item.price) {
        priceDiv.innerHTML = "$" + item.price.toFixed(2) + " " + item.dev;
        priceDiv.classList.add("articlePriceWrapperDiv")
    }
    let nunDiv = document.createElement("div");
    if (item.nun && showNun) {
        nunDiv.innerHTML = "NUN : " + item.nun;
        nunDiv.classList.add("articleNunWrapperDiv");
    }


    row.appendChild(imgWrapperDiv);
    articleWrapperDiv.appendChild(refDiv);
    articleWrapperDiv.appendChild(priceDiv);
    articleWrapperDiv.appendChild(nunDiv);
    row.appendChild(articleWrapperDiv);

    if (item.returned || item.exchanged || item.warrantied) {
        row.classList.add("articleNotAvailable");
        row.appendChild(templatesWrapper.querySelector(".articleInfoEllipse").cloneNode(true));

        if (item.returned) row.appendChild(templatesWrapper.querySelector(".articleReturnedPopup").cloneNode(true));
        else if (item.exchanged) row.appendChild(templatesWrapper.querySelector(".articleExchangedPopup").cloneNode(true));
        else if (item.warrantied) row.appendChild(templatesWrapper.querySelector(".articleWarrantiedPopup").cloneNode(true));
    }
    return row;
}

function fillFinalCheck() {
    agreeTermsCheckboxInput.checked = false;
    swiperNextBtnEl.classList.add("swiperBtn");
    swiperNextBtnEl.classList.remove("swiper-button-disabled");
    nextBtn.classList.add("d-none");
    sendBtn.classList.remove("d-none");
    sendBtn.disabled = true;
    allowNextSlideBtn(false);

    const returnOutSref1 = returnOutSelectedSref1?.dataset.value;
    const returnOutSref2 = returnOutSelectedSref2?.dataset.value;
    //Request type
    Array.from(finalCheckRequestType.children).forEach(typeEl => {
        if (typeEl.dataset.type == returnType) typeEl.classList.remove("d-none")
        else typeEl.classList.add("d-none")
    });

    //Reason
    const returnTypeWithReason = ["R", "W"];
    if (returnTypeWithReason.includes(returnType)) {
        finalCheckReasonWrapper.classList.remove("d-none");

        const prefixSplit = returnReason.split("_");
        const firstQuestionPrefix = prefixSplit[0];
        let reason = "";

        if (returnType == "R" || returnType == "R-W") {
            if (firstQuestionPrefix) reason += "<b>" + returnQuestionTwoSlide.querySelector("div[data-type=" + firstQuestionPrefix + "]")?.querySelector(".selectableDivText")?.innerText;
            if (prefixSplit.length > 1) reason += " > " + returnQuestionThreeSlide.querySelector("div[data-type=" + returnReason + "]")?.querySelector(".selectableDivText")?.innerText + "</b><br />";
            else reason += "</b><br />"
            if (returnReasonOtherInput.value) {
                reason += returnReasonOtherInput.value;
                returnReasonDescription = returnReasonOtherInput.value;
            }
        }
        else if (returnType == "W" || returnType == "W-BO") {
            if (firstQuestionPrefix) reason += "<b>" + warrantyQuestionOneSlide.querySelector("div[data-type=" + firstQuestionPrefix + "]")?.querySelector(".selectableDivText")?.innerText + "</b><br />";
            if (defectDescriptionInput.value) {
                reason += defectDescriptionInput.value;
                returnReasonDescription = defectDescriptionInput.value;
            }
        }

        finalCheckReason.innerHTML = reason;
    }
    else finalCheckReasonWrapper.classList.add("d-none");

    //Low / out stock warning for exchange
    finalCheckLowOnStockWarning.classList.add("d-none");
    finalCheckOutOfStockWarning.classList.add("d-none");
    if (returnOutSref1 && returnOutSref2) {
        const stockArticleOut = selectedItemOut.stocks.find(stock => stock.ref == selectedItemOut.ref && stock.sref1 == returnOutSref1 && stock.sref2 == returnOutSref2);
        const avStock = stockArticleOut.stqte - stockArticleOut.resqte;
        if (avStock <= 0) finalCheckOutOfStockWarning.classList.remove("d-none");
        else if (avStock < lowStockTreshold) finalCheckLowOnStockWarning.classList.remove("d-none");
    }

    //Request articles involved
    finalCheckReturnIn.innerHTML = "";
    finalCheckReturnOut.innerHTML = "";

    const articleInBox = createArticleElement(selectedWrongItem ?? selectedItemIn, yourModelTitleClass);
    articleInBox.classList.add("noHover");
    articleInBox.classList.add("border-0");

    finalCheckReturnIn.appendChild(articleInBox);

    if (selectedItemOut && (selectedItemOut.ref != selectedItemIn.ref || selectedItemOut.sref1 != selectedItemIn.sref1 || selectedItemOut.sref2 != selectedItemIn.sref2)) {
        const articlOutBox = createArticleElement(selectedItemOut, newModelTitleClass);
        articlOutBox.classList.add("noHover");
        articlOutBox.classList.add("border-0");

        const yourModelText = templatesWrapper.querySelector(".YourModelText").innerHTML;
        const innerTextOut = articlOutBox.querySelector(".articleRefWrapperDiv");
        const requestedModelText = templatesWrapper.querySelector(".YourRequestedModelText").innerHTML;
        innerTextOut.innerHTML = innerTextOut.innerHTML.replaceAll(yourModelText, requestedModelText);

        finalCheckReturnOut.appendChild(articlOutBox);
        finalCheckReturnOutArrow.classList.remove("d-none");
    }
    else finalCheckReturnOutArrow.classList.add("d-none");

    //Shipping address for article going out
    if (selectedItemOut || returnType == "W") {
        updateShippingAddressInfo();
        finalCheckShippingAddressWrapper.classList.remove("d-none");
    }
    else finalCheckShippingAddressWrapper.classList.add("d-none");

    //Images
    const returnTypeWithImages = ["R", "R-W", "E", "E-W", "W"];
    if (returnTypeWithImages.includes(returnType)) {
        finalCheckImagesWrapper.classList.remove("d-none");
        finalCheckImages.innerHTML = "";
        imageElements.forEach(imageEl => {
            const wrapper = document.createElement("div");
            wrapper.className = "d-flex flex-column align-items-center";

            const container = document.createElement("div");
            container.className = "finalCheckImageContainer d-flex align-items-center";
            container.appendChild(imageEl.cloneNode(true));

            const typeNameP = document.createElement("p");
            typeNameP.className = "mb-0";
            const imageTitle = imageTitles.find(imageTitle => imageTitle.dataset.type == imageEl.dataset.type);
            typeNameP.innerText = imageTitle?.innerText;

            wrapper.appendChild(container);
            wrapper.appendChild(typeNameP);

            finalCheckImages.appendChild(wrapper);
        });
    }
    else finalCheckImagesWrapper.classList.add("d-none");
}

function editShippingAddressClicked() {
    shippingAddressInfoWrapper.classList.add("collapsed");
    shippingAddressEditWrapper.classList.remove("collapsed");
    editShippingAddressBtn.classList.add("d-none");

    swiperReturn.update();
    setTimeout(() => swiperReturn.update(), 150);
}

function updateShippingAddressInfo() {
    finalCheckShippingFName.innerHTML = selectedOrder.shipping_address.first_name ? selectedOrder.shipping_address.first_name : "-";
    finalCheckShippingLName.innerHTML = selectedOrder.shipping_address.last_name ? selectedOrder.shipping_address.last_name : "-";

    if (selectedOrder.shipping_address.cie) {
        finalCheckShippingCompany.innerHTML = selectedOrder.shipping_address.cie;
        finalCheckShippingCompanyWrapper.classList.remove("d-none");
    }
    else finalCheckShippingCompanyWrapper.classList.add("d-none");

    finalCheckShippingAddress.innerHTML = selectedOrder.shipping_address.street ? selectedOrder.shipping_address.street : "-";

    if (selectedOrder.shipping_address.loc){
        finalCheckShippingLoc.innerHTML = selectedOrder.shipping_address.loc;
        finalCheckShippingLocWrapper.classList.remove("d-none");
    }
    else{
        finalCheckShippingLocWrapper.classList.add("d-none");
    }

    finalCheckShippingCity.innerHTML = selectedOrder.shipping_address.city ? selectedOrder.shipping_address.city : "-";
    finalCheckShippingState.innerHTML = Array.from(shippingAddressEditState.options).find(option => option.value === selectedOrder.shipping_address.state)?.value ?? "-";
    finalCheckShippingCPostal.innerHTML = selectedOrder.shipping_address.zip ? selectedOrder.shipping_address.zip : "-";

    if (selectedOrder.shipping_address.phone){
        finalCheckShippingPhone.innerHTML = selectedOrder.shipping_address.phone;
        finalCheckShippingPhoneWrapper.classList.remove("d-none");
    }
    else{
        finalCheckShippingPhoneWrapper.classList.add("d-none");
    }
}

function resetShippingAddressEdit() {
    shippingAddressEditFName.value = "";
    shippingAddressEditLName.value = "";
    shippingAddressEditCompany.value = "";
    shippingAddressEditAddress.value = "";
    shippingAddressEditLoc.value = "";
    shippingAddressEditCity.value = "";
    shippingAddressEditState.value = "";
    shippingAddressEditCPostal.value = "";
    shippingAddressEditPhone.value = "";

    shippingAddressInfoWrapper.classList.remove("collapsed");
    shippingAddressEditWrapper.classList.add("collapsed");
    editShippingAddressBtn.classList.remove("d-none");

    saveShippingAddressEditBtn.disabled = true;

    swiperReturn.update();
}

function saveShippingAddressEdit() {
    //Address was modified so remove the address id
    selectedOrder.shipping_address_id = null;

    selectedOrder.shipping_address.first_name = shippingAddressEditFName.value;
    selectedOrder.shipping_address.last_name = shippingAddressEditLName.value;
    selectedOrder.shipping_address.cie = shippingAddressEditCompany.value;
    selectedOrder.shipping_address.street = shippingAddressEditAddress.value;
    selectedOrder.shipping_address.loc = shippingAddressEditLoc.value;
    selectedOrder.shipping_address.city = shippingAddressEditCity.value;
    selectedOrder.shipping_address.state = shippingAddressEditState.value;
    selectedOrder.shipping_address.zip = shippingAddressEditCPostal.value;
    selectedOrder.shipping_address.phone = shippingAddressEditPhone.value;
    selectedOrder.shipping_address.valid = null;

    updateShippingAddressInfo();
    resetShippingAddressEdit();
}

function shippingAddressEditInputChange() {
    saveShippingAddressEditBtn.disabled = !checkShippingAddressEditValidity();
}

function checkShippingAddressEditValidity() {
    if (!shippingAddressEditFName.value) return false;
    if (!shippingAddressEditLName.value) return false;
    if (!shippingAddressEditAddress.value) return false;
    if (!shippingAddressEditCity.value) return false;
    if (!shippingAddressEditState.value) return false;
    if (!shippingAddressEditCPostal.value) return false;

    //Canada only, add space between the first thre char and the last three
    if (shippingAddressEditCPostal.value.length == 6 && !shippingAddressEditCPostal.value.includes(" ")) shippingAddressEditCPostal.value = shippingAddressEditCPostal.value.substring(0, 3) + " " + shippingAddressEditCPostal.value.substring(3);
    // Regular expression for Canadian postal code format
    if (!/^[A-Za-z]\d[A-Za-z] ?\d[A-Za-z]\d$/.test(shippingAddressEditCPostal.value)) return false;

    return true;
}

function slideChangeTransitionStart(swiper) {
    const previousIdx = swiper.previousIndex;
    const activeIdx = swiper.activeIndex;

    const prevSlide = swiper.slides[previousIdx];
    const prevSlideFamilies = prevSlide.dataset.slide_family.split(",");

    //If the slide isn't valid for the current type chosen continue to next valid one
    let newIdx = activeIdx;
    let newSlide = swiper.slides[activeIdx];
    let newSlideFamilies = newSlide.dataset.slide_family.split(",");
    while (!(newIdx == 0 || newIdx == swiper.slides.length - 1 || ((newSlideFamilies.includes("common") || newSlideFamilies.includes(returnType)) && slideReasonCheck(newSlide)))) {
        newSlide = swiper.slides[previousIdx > activeIdx ? --newIdx : ++newIdx];
        newSlideFamilies = newSlide.dataset.slide_family.split(",");
    }
    if (newIdx != activeIdx) {
        swiper.allowSlideNext = true;
        swiper.slideTo(newIdx);
        return;
    }
    const indexes = [previousIdx, newIdx];

    let lowerCutOff;
    let upperCutOff;
    //If the slide it was currently on is wrong then also hide that slide
    if ((!prevSlideFamilies.includes("common") && !prevSlideFamilies.includes(returnType)) || !slideReasonCheck(newSlide)) {
        lowerCutOff = Math.min(...indexes);
        upperCutOff = Math.max(...indexes);

        if (previousIdx > activeIdx) {
            lowerCutOff++;
            upperCutOff++;
        }
    }
    else {
        lowerCutOff = Math.min(...indexes) + 1;
        upperCutOff = Math.max(...indexes);
    }

    swiper.slides.slice(lowerCutOff, upperCutOff).forEach(slide => { slide.classList.add("invisible") });
}

function slideChange(swiper) {
    //If it took less than 50ms to change the slide after gaining focus than assume that it was the bug changing the slide and change it back
    //I couldn't find a better fix to the slide on focus bug at worst the user is going to have to click twice on something when the click was tabbing in
    if (performance.now() - timer < 50) {
        timer = 0;
        //Go back to previous slide
        allowNextSlideBtn(true);
        swiper.slideTo(swiper.previousIndex);
        return;
    }
    //By default use next button not send
    nextBtn.classList.remove("d-none");
    sendBtn.classList.add("d-none");

    document.body.scrollIntoView();

    const previousIdx = swiper.previousIndex;
    const activeIdx = swiper.activeIndex;
    const currentSlide = swiper.slides[activeIdx];

    swiperNextBtnEl.classList.remove("swiperBtn")
    swiperNextBtnEl.onclick = null;

    const crtSlideFamilies = currentSlide.dataset.slide_family.split(",");
    //If the current slide isn't valid for the current return type don't setup anything because the slide will be skipped over anyways
    if ((!crtSlideFamilies.includes("common") && !crtSlideFamilies.includes(returnType)) || !slideReasonCheck(currentSlide)) {
        return;
    }

    if (currentSlide == orderSelectionSlide) {
    }
    if (currentSlide == articleSelectionSlide) {
        //Remove the "wrong" suffix from the return type (it will be added again if they click on the article not here button)
        if (returnType.endsWith("-W")) returnType = returnType.slice(0, -2);
        if (crtSelectedRow) {
            swiperNextBtnEl.classList.add("swiperBtn")
            allowNextSlideBtn(true);
        }
        else {
            swiperNextBtnEl.classList.remove("swiperBtn")
            allowNextSlideBtn(false);
        }
    }
    else if (currentSlide == wrongBootsSizeSelectionSlide) {
        if (checkSrefSelection(wrongBootsSelectedSref1, wrongBootsSelectedSref2, selectedWrongItem)) {
            swiperNextBtnEl.classList.add("swiperBtn")
            allowNextSlideBtn(true);
        }
        else {
            swiperNextBtnEl.classList.remove("swiperBtn")
            allowNextSlideBtn(false);
        }
    }
    else if (currentSlide == wrongBootsShouldReceiveSlide) {
        if (crtSelectedRow) {
            swiperNextBtnEl.classList.add("swiperBtn")
            allowNextSlideBtn(true);
        }
        else {
            swiperNextBtnEl.classList.remove("swiperBtn")
            allowNextSlideBtn(false);
        }
    }
    else if (currentSlide == exchangeSizeSelectionSlide) {
        if (checkSrefSelection(returnOutSelectedSref1, returnOutSelectedSref2, selectedItemOut)) {
            swiperNextBtnEl.classList.add("swiperBtn")
            allowNextSlideBtn(true);
        }
        else {
            setupReturnOut();
        }
    }
    else if (currentSlide == returnQuestionThreeSlide) {
    }
    else if (currentSlide == returnQuestionThreeOtherSlide) {
        fillArticleBox(returnQuestionThreeOtherArticleBox, selectedItemIn);
        swiperNextBtnEl.classList.add("swiperBtn")
        allowNextSlideBtn(true);
    }
    else if (currentSlide == warrantyQuestionOneSlide) {
        fillArticleBox(warrantyQuestionOneArticleBox, selectedItemIn);
        allowNextSlideBtn(false);
    }
    else if (currentSlide == imagesSlide) {
        fillArticleBox(imageArticleBox, selectedWrongItem ?? selectedItemIn);
        if (returnType == "W") {
            defectDescriptionWrapper.classList.remove("d-none");
            defectDescriptionTitle.innerText = warrantyQuestionOneSlide.querySelector("div[data-type=" + returnReason + "]")?.querySelector(".selectableDivText")?.innerText
        }
        else {
            defectDescriptionWrapper.classList.add("d-none");
        }

        //if all the images are now filled (or we are currently from an internal IP) allow next slide
        let nextSlideAllowed = imageInputs.every(input => Array.from(input.files).filter(file => file.type.includes('image')).length != 0) || isIpRestricted;

        allowNextSlideBtn(nextSlideAllowed);
        if (nextSlideAllowed) swiperNextBtnEl.classList.add("swiperBtn");
        else swiperNextBtnEl.classList.remove("swiperBtn");
    }
    else if (currentSlide == finalCheckSlide) {
        fillFinalCheck();
    }

    //Hide element not from the current type
    if (returnType) {
        currentSlide.querySelectorAll("*[data-types]").forEach(child => {
            if (child.dataset.types) {
                if (child.dataset.types.split(",").includes(returnType)) {
                    child.classList.remove("d-none");
                }
                else child.classList.add("d-none");
            }
        });
    }
}

function slideChangeTransitionEnd(swiper) {
    const previousIdx = swiper.previousIndex;
    const activeIdx = swiper.activeIndex;
    const indexes = [previousIdx, activeIdx];
    const prevSlide = swiper.slides[previousIdx];
    const prevSlideFamilies = prevSlide.dataset.slide_family.split(",");

    let lowerCutOff;
    let upperCutOff;
    //If the slide it was currently on is wrong then also hide that slide
    if (!prevSlideFamilies.includes("common") && !prevSlideFamilies.includes(returnType)) {
        lowerCutOff = Math.min(...indexes);
        upperCutOff = Math.max(...indexes);

        if (previousIdx > activeIdx) {
            lowerCutOff++;
            upperCutOff++;
        }
    }
    else {
        lowerCutOff = Math.min(...indexes) + 1;
        upperCutOff = Math.max(...indexes);
    }

    swiper.slides.slice(lowerCutOff, upperCutOff).forEach(slide => { slide.classList.remove("invisible") });
}

function allowNextSlideBtn(allow) {
    swiperReturn.allowSlideNext = allow;
}

function scrollToCenterOfEl(el, smooth = true) {
    const rect = el.getBoundingClientRect();
    const top = (rect.top + window.scrollY) - (screen.height / 2) + (rect.height / 2);
    window.scroll({
        top: top,
        behavior: smooth ? 'smooth' : 'instant'
    });
}

function splitLastOccurrence(str, substring) {
    const lastIndex = str.lastIndexOf(substring);

    const before = str.slice(0, lastIndex);

    const after = str.slice(lastIndex + 1);

    return [before, after];
}

function getIndexOfChild(el) {
    return [].indexOf.call(el.parentNode.children, el);
}

/**Checks if the slide given is valid with the current reasons */
function slideReasonCheck(slide) {
    if (!slide.dataset.slide_reasons && !slide.dataset.slide_not_reasons) return true;
    let isValid = true;
    if (slide.dataset.slide_reasons) {
        slideReasons = slide.dataset.slide_reasons.split(",");
        const validationArr = []
        slideReasons.forEach(reason => {
            const splitReason = reason.split("_");
            const splitReturnReason = returnReason.split("_");
            if (!returnReason) return false;
            //Check if reason is in it or if there is a wild card if stuff after the wild card is in it
            if (reason !== returnReason && (splitReason.length === 1 || splitReturnReason.length === 1 || (splitReason[0] === "*" && splitReason[1] !== splitReturnReason[1]))) validationArr.push(false);
            else validationArr.push(true);
        });
        //If none of the possible reasons where valid then it's not valid
        if (!validationArr.some(valid => valid)) isValid = false;
    }
    if (slide.dataset.slide_not_reasons) {
        slideNotReasons = slide.dataset.slide_not_reasons.split(",");
        slideNotReasons.forEach(reason => {
            const splitReason = reason.split("_");
            const splitReturnReason = returnReason.split("_");
            //No need to check if there is no return reason
            if (returnReason) {
                //Check if reason is in it or if there is a wild card if stuff after the wild card is in it
                if (reason === returnReason || (splitReason.length !== 1 && splitReturnReason.length !== 1 && (splitReason[0] === "*" && splitReason[1] === splitReturnReason[1]))) isValid = false;
            }
        });
    }
    return isValid;
}

function formatDate(date) { return new Date(date.getTime() - (date.getTimezoneOffset()*60*1000)).toISOString().split('T')[0];}